import * as React from 'react';
import { GetField } from "./Helpers";


export const Advertising = (props) => {

    const dispTimer = React.useRef(null);
    const currentAd = React.useRef(0);
    const [content, setContent] = React.useState("");

    React.useEffect(() => {
        if (dispTimer.current == null) {
            DisplayContent(props.content[0].content);
            if (props.content.length > 0) dispTimer.current = setTimeout(ShowNextAd, props.content[0].displayTime * 1000);
        }
        return () => { // kill any timers when leaving page
            if (dispTimer.current !== null) clearTimeout(dispTimer.current);
        }
    }, [props.content]);

    const ShowNextAd = () => {
        currentAd.current++;
        if (currentAd.current >= props.content.length) currentAd.current = 0;
        DisplayContent(props.content[currentAd.current].content);
        dispTimer.current = setTimeout(ShowNextAd, props.content[currentAd.current].displayTime * 1000);
    }

    const DisplayContent = (c) => {
        if (String(c).indexOf("data:image") === 0) {
            setContent(<div className="AdImageCentre"><img className="AdImage" src={c}></img></div>);
        } else {
            let sz = "AdText";
            if (c.length > 200) sz += " AdTextSmall";
            setContent(<div className={sz}>{c}</div>);
        }
    }

    const Adclick = () => {
        if (props.stopAds) props.stopAds();
    }

    return (
        <div id="Advertising" onClick={Adclick}>
            {content}
        </div>
    );
}